import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "classroomSelect",
    "spinner",
    "dateSelection",
    "batchButton"
  ]

  connect() {
    this.checkInitialSelection()
  }

  classroomChanged() {
    const classroomId = this.classroomSelectTarget.value

    if (classroomId === "") return

    this.enableBatchButton()
    this.showSpinner()

    fetch(`/date_selection?level_id=${classroomId}`)
      .then(res => res.text())
      .then(html => {
        this.dateSelectionTarget.innerHTML = html
        this.hideSpinner()
        this.setupDateChangeListener()
      })
  }

  setupDateChangeListener() {
    const chooseDateSelect = this.dateSelectionTarget.querySelector("#choose_date")
    if (chooseDateSelect) {
      chooseDateSelect.addEventListener("change", () => this.dateChanged(chooseDateSelect.value))
      this.dateChanged(chooseDateSelect.value) // auto-trigger on insert if needed
    }
  }

  dateChanged(value) {
    const [date, levelId] = value.split("#")

    this.showSpinner()

    fetch(`/level_students?choose_date=${encodeURIComponent(value)}`, {
      headers: { "Accept": "text/javascript" }
    })
      .then(response => response.text())
      .then(js => {
        this.hideSpinner()

        const script = document.createElement("script")
        script.text = js
        document.body.appendChild(script)
        document.body.removeChild(script)
      })
  }

  checkInitialSelection() {
    if (this.classroomSelectTarget.value !== "") {
      this.classroomChanged()
    }
  }

  enableBatchButton() {
    if (this.hasBatchButtonTarget) {
      this.batchButtonTarget.disabled = false
    }
    this.classroomSelectTarget.classList.remove("is-invalid")
  }

  showSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.style.display = "inline-block"
    }
  }

  hideSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.style.display = "none"
    }
  }
}
